function navBackground() {
    // navbar scroll bg change
	const navbar = document.querySelector('.navbar');
	window.addEventListener('scroll', function (){
		if (window.scrollY > 30) {
			navbar.classList.remove('bg-transparent');
			navbar.classList.add('bg-dark');
		} else {
			navbar.classList.remove('bg-dark');
			navbar.classList.add('bg-transparent');
		}
	});
}

export { navBackground as default };